(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["customer-personal-details"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-personal-details]').forEach(root => {
      const display = root.querySelector('[data-personal-display]');
      const form = root.querySelector('[data-personal-form]');
      const editBtn = root.querySelector('[data-personal-edit]');
      const cancelBtn = root.querySelector('[data-personal-cancel]');

      if (editBtn && display && form) {
        editBtn.addEventListener('click', () => {
          display.hidden = true;
          form.hidden = false;
        });
      }
      if (cancelBtn && display && form) {
        cancelBtn.addEventListener('click', () => {
          display.hidden = false;
          form.hidden = true;
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["customer-saved-pieces"] && !Shopify.designMode) return;
  try {
    (function () {
    const STORAGE_KEY = 'nevelson_saved';

    document.querySelectorAll('[data-saved-pieces]').forEach(async root => {
      const empty = root.querySelector('[data-saved-empty]');
      const list = root.querySelector('[data-saved-list]');
      const template = root.querySelector('[data-saved-template]');
      if (!list || !template) return;

      let handles = [];
      try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (raw) handles = JSON.parse(raw) || [];
      } catch (e) {
        handles = [];
      }

      if (!Array.isArray(handles) || handles.length === 0) return;

      const renderItem = (product, handle) => {
        const node = template.content.firstElementChild.cloneNode(true);
        node.href = '/products/' + handle;
        const img = node.querySelector('.saved-pieces__image');
        const title = node.querySelector('.saved-pieces__title');
        const price = node.querySelector('.saved-pieces__price');
        const remove = node.querySelector('[data-saved-remove]');

        if (product.featured_image) {
          img.src = product.featured_image;
        }
        img.alt = product.title || '';
        title.textContent = product.title || handle;

        const priceCents = product.price;
        if (typeof priceCents === 'number') {
          price.textContent = '$' + (priceCents / 100).toFixed(0);
        }

        remove.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          let current = [];
          try {
            const raw = window.localStorage.getItem(STORAGE_KEY);
            if (raw) current = JSON.parse(raw) || [];
          } catch (_) {}
          current = current.filter(h => h !== handle);
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(current));
          node.remove();
          if (!list.querySelector('.saved-pieces__item')) {
            list.hidden = true;
            if (empty) empty.hidden = false;
          }
        });

        list.appendChild(node);
      };

      const fetched = await Promise.all(
        handles.map(h =>
          fetch('/products/' + encodeURIComponent(h) + '.js')
            .then(r => r.ok ? r.json() : null)
            .catch(() => null)
        )
      );

      fetched.forEach((product, i) => {
        if (product) renderItem(product, handles[i]);
      });

      if (list.querySelector('.saved-pieces__item')) {
        list.hidden = false;
        if (empty) empty.hidden = true;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-card-carousel]').forEach(carousel => {
    const card = carousel.closest('.product-card');
    const dotsContainer = card.querySelector('[data-card-dots]');
    if (!dotsContainer) return;

    const dots = dotsContainer.querySelectorAll('.product-card__dot');
    let isSwiping = false;

    carousel.addEventListener('scroll', () => {
      const scrollLeft = carousel.scrollLeft;
      const slideWidth = carousel.offsetWidth;
      const activeIndex = Math.round(scrollLeft / slideWidth);

      dots.forEach((dot, i) => {
        dot.classList.toggle('product-card__dot--active', i === activeIndex);
      });
    });

    carousel.addEventListener('touchstart', () => { isSwiping = false; }, { passive: true });
    carousel.addEventListener('touchmove', () => { isSwiping = true; }, { passive: true });

    card.addEventListener('click', (e) => {
      if (isSwiping) {
        e.preventDefault();
        isSwiping = false;
      }
    });

    const prevBtn = card.querySelector('[data-card-prev]');
    const nextBtn = card.querySelector('[data-card-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        carousel.scrollBy({ left: -carousel.offsetWidth, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        carousel.scrollBy({ left: carousel.offsetWidth, behavior: 'smooth' });
      });
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    const scrollBtn = document.querySelector('[data-scroll-to-top]');
  if (scrollBtn) {
    scrollBtn.hidden = false;

    window.addEventListener('scroll', () => {
      scrollBtn.classList.toggle('visible', window.scrollY > 500);
    }, { passive: true });

    scrollBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
